import React from 'react';
import {
    StyledSearchAssistButtonClose,
    StyledSearchAssistModal,
    StyledSearchAssistModalContent,
    StyledSearchAssistModalHeader
} from "./style";
import {createPortal} from "react-dom";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";
import IconCloseUi from "../../../../shared/ui/icons/icon-close.ui";

interface IProps {
    children: React.ReactNode;
    onClose?: () => void;
    modalPosition: {
        top: number;
        left: number;
        height: number;
    }
    isOpen: boolean;
    modalRef: React.RefObject<HTMLDivElement | null>;
    slotSuggestion?: React.ReactNode;
}

/**
 * * Модальное окно, которое внутри себя отображает слот с подсказками и основной контент результата поиска и фильтра.
 *  * Также принимает параметры позиционирования относительно `document.body`.
 *
 * @returns {JSX.Element} -  Модальное окно с подсказками и контентом.
 *
 */
const SearchAssistModal: React.FC<IProps> = ({children, onClose, modalPosition, isOpen, modalRef, slotSuggestion}) => {

    const classname = `${GLOBAL_STYLE_CONFIG.splitByPrefix('search-modal')}`
    return createPortal(
        <StyledSearchAssistModal ref={modalRef}
                                 className={classname}
                                 top={modalPosition.top}
                                 left={modalPosition.left}
                                 height={modalPosition.height}
                                 isOpen={isOpen}
        >
            <StyledSearchAssistModalHeader className={GLOBAL_STYLE_CONFIG.splitByPrefix('search-modal-header')}>
                {slotSuggestion && slotSuggestion}
                <StyledSearchAssistButtonClose onClick={onClose}
                                               className={GLOBAL_STYLE_CONFIG.splitByPrefix('modal-close')}>
                    <IconCloseUi width={22} height={22}

                    />
                </StyledSearchAssistButtonClose>
            </StyledSearchAssistModalHeader>
            <StyledSearchAssistModalContent className={GLOBAL_STYLE_CONFIG.splitByPrefix('search-modal-content')}>
                {children}
            </StyledSearchAssistModalContent>
        </StyledSearchAssistModal>,
        document.body
    );
};

export default SearchAssistModal;